var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"mb-3 input-container",attrs:{"column":_vm.$vuetify.breakpoint.xsOnly,"justify-start":"","align-start":""}},[_c('v-flex',{staticClass:"label",staticStyle:{"width":"110px"}},[_vm._v(" "+_vm._s(_vm.label)+" "),(!_vm.optional)?_c('span',[_vm._v("*")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }